module.exports = __webpack_public_path__ + "media/draw.a9bc731e.mp3";